import { computed, getCurrentInstance } from '@vue/composition-api';
import { closeLogoutUserDialog, logoutUserDialog } from '@/shared/utils/logoutUserDialog';
import store from '@/store';
import { Vue } from 'vue-property-decorator';
import type { ComputedRef } from '@vue/composition-api';

/**
 * 用户认证状态管理 Hook
 * 检查用户是否已注销，并根据情况显示相应的弹窗
 */
export function useUserAuth(): {
  isLogoutUser: ComputedRef<boolean>;
  isHybridAppMode: ComputedRef<boolean>;
  checkIsLogoutUser: () => boolean;
  } {
  const instance = getCurrentInstance();

  // 获取用户是否已注销的状态
  const isLogoutUser = computed(() => store.state.base.isLogoutUser);
  // 获取是否为混合应用模式
  const isHybridAppMode = computed(() => store.state.base.isHybridAppMode);

  /**
   * 检查是否为已注销用户
   * 如果是已注销的用户，则弹窗提示更换账号
   * @returns {boolean} 返回用户是否已注销
   */
  const checkIsLogoutUser = (): boolean => {
    if (isLogoutUser.value) {
      /**
       * 传入当前组件实例，保持与原有 API 兼容
       * 在 Vue 2 的 composition API 中，需要类型断言
       */
      logoutUserDialog(instance as unknown as Vue);
    } else {
      /** 修复借钱Tab在后台加载"臻有钱"时，token错误，导致已注销弹窗展示错误 */
      if (isHybridAppMode.value) {
        closeLogoutUserDialog();
      }
    }

    return isLogoutUser.value;
  };

  return {
    isLogoutUser,
    isHybridAppMode,
    checkIsLogoutUser,
  };
}
